var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cce9ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(778 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16,
    transform: "translate(-778 228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.769,10.417v2h2l4-5-1-2Zm8-4a1.087,1.087,0,0,0,0-1l-1-1a1.087,1.087,0,0,0-1,0l-1,1,2,2Z",
    transform: "translate(-778.769 227.583)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon2);
export default __webpack_public_path__ + "static/media/EditIcon2.06925997a494d9a0bc6761a74cec3770.svg";
export { ForwardRef as ReactComponent };